import { FormatOptions } from '@ch/common/components/form/date/date';
import { DateTime } from 'luxon';
import { FormApiInterface } from 'react-uforms';
import { ValidatorInterface } from 'react-uforms/dist/components/validator';
import { convertToSeconds, YearsConst } from './age-unit';

export enum DateComparisonMode {
  Greater,
  Lower,
}

const getDate = (str: string, format: FormatOptions) => DateTime.fromFormat(str, format).set({ hour: 0, minute: 0 });

export const dateValidation = ({
  api,
  identifier1,
  identifier2,
  mode,
  message,
}: {
  api: FormApiInterface;
  identifier1: string;
  identifier2: string;
  mode: DateComparisonMode;
  message: string;
}): ValidatorInterface => (valueStr2: string) => {
  const valueStr1 = api?.getValue(identifier2);
  const date1Format = api?.getValue(`${identifier2}_FormatOption`) || FormatOptions.FULL_DATE;
  const date2Format = api?.getValue(`${identifier1}_FormatOption`) || FormatOptions.FULL_DATE;

  if (!valueStr1 || !valueStr2) {
    return true;
  }

  let date1 = getDate(valueStr1, date1Format);
  let date2 = getDate(valueStr2, date2Format);

  if (!date1.isValid || !date2.isValid) {
    return true;
  }

  if (date1Format === FormatOptions.MONTH_YEAR || date2Format === FormatOptions.MONTH_YEAR) {
    date1 = date1.set({ day: 1 });
    date2 = date2.set({ day: 1 });
  }

  if (date1Format === FormatOptions.YEAR || date2Format === FormatOptions.YEAR) {
    date1 = date1.set({ month: 1 });
    date2 = date2.set({ month: 1 });
  }

  const condition = mode === DateComparisonMode.Greater ? date1 >= date2 : date1 <= date2;

  if (!condition) {
    return message;
  }

  return true;
};

export const minNumberValidation = (minNumber, message): ValidatorInterface => (value: string) => {
  if (+minNumber > +value) {
    return message;
  }

  return true;
};

export const maxNumberValidation = (maxNumber, message): ValidatorInterface => (value: string) => {
  if (+maxNumber < +value) {
    return message;
  }

  return true;
};

export const ageValidation = (api, min, max, identifier, message): ValidatorInterface => (value: string) => {
  const ageUnit = api?.getValue(identifier) || YearsConst;
  const minSecond = convertToSeconds(min, YearsConst);
  const maxSecond = convertToSeconds(max, YearsConst);
  const valueSecond = convertToSeconds(+value, ageUnit);

  if (value && (minSecond > valueSecond || valueSecond > maxSecond)) {
    return message;
  }

  return true;
};

export const validationMessage = (message: string, defaultMessage: string) => {
  return message && message.length > 0 ? message : defaultMessage;
};
